// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardLoadingSpinner-cls1_4YP","cls2":"BigCardLoadingSpinner-cls2_xG9 BigCardLoadingSpinner-cls1_4YP","truncate":"BigCardLoadingSpinner-truncate_amp"};